import { useState, useEffect } from 'react';
import useStore from './store';
import { bookingRepository } from '../../../domain/bookingRepository';


export const useBookingData = () => {

    const data = useStore((state) => state.bookingData)
    const setData = useStore((state) => state.setBookingData)

    const [isLoading, setIsLoading] = useState(!data);

    useEffect(() => { // Axios request use to be inside useEffect to get executed once.
        if (!data) {
            setIsLoading(true)
            bookingRepository.getBookingData()
                .then((data) => {
                    setData(data)
                    setIsLoading(false)
                })
                .catch((err) => {
                    console.error("Failed to fetch decoration types:", err)
                    setIsLoading(false)
                });
        } else {
            setIsLoading(false)
        }
    }, [data, setData]);

    return { data, isLoading };
};